import React from 'react';
import { Sentry } from '../services/sentry';

/**
 * Uygulamanın en dış hata sınırı. Yoksa bir ekran parçası inemediğinde (yavaş bağlantı, deploy sonrası eski parça)
 * ya da render hatasında React bütün ağacı kaldırıyor, kullanıcı düğmesiz boş bir ekranda kalıyordu (2026-10-13).
 * Parça hatasında services/sentry.ts sayfayı kendisi yeniliyorsa "yükleniyor" gösterilir.
 */
export default class AppErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
    state = { error: null as Error | null };

    static getDerivedStateFromError(error: Error) {
        return { error };
    }

    componentDidCatch(error: Error) {
        if (!(window as any).__kpssChunkReloading) Sentry.captureException(error);
    }

    render() {
        if (!this.state.error) return this.props.children;
        const reloading = !!(window as any).__kpssChunkReloading;
        return (
            <div style={{ position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, background: '#0f172a', color: '#e2e8f0', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
                {reloading ? (
                    <>
                        <div className="loader" />
                        <p style={{ fontWeight: 700 }}>Uygulama yükleniyor…</p>
                    </>
                ) : (
                    <>
                        <p style={{ fontSize: 40 }}>📶</p>
                        <p style={{ fontWeight: 800, fontSize: 18 }}>Uygulama yüklenemedi</p>
                        <p style={{ fontSize: 14, color: '#94a3b8', maxWidth: 320 }}>İnternet bağlantın yavaş ya da kesik olabilir. Bağlantını kontrol edip tekrar dene.</p>
                        <button
                            onClick={() => window.location.reload()}
                            style={{ padding: '12px 28px', borderRadius: 14, border: 0, background: 'linear-gradient(90deg,#f59e0b,#f97316)', color: '#0f172a', fontWeight: 900, fontSize: 16, cursor: 'pointer' }}
                        >
                            Yeniden yükle
                        </button>
                    </>
                )}
            </div>
        );
    }
}
